export const SWITCHES = {
  forceLoggersGoogleSignin: 'force_loggers_google_signin',
  sendCaughtErrorsToSentry: 'send_caught_errors_to_sentry',
  useSingleSignUpURL: 'use_single_signup_url'
};

export default SWITCHES;
